import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Alert, Avatar } from '@/components/ui'
import { moverCandidatura } from '../api'
import { ETAPA_COLORS, ETAPA_LABELS, ETAPAS_KANBAN } from '../constants'
import type { PipelineMap } from '../types'

type Props = {
  vagaId: string
  pipeline: PipelineMap
}

export function PipelineBoard({ vagaId, pipeline }: Props) {
  const qc = useQueryClient()
  const mover = useMutation({
    mutationFn: ({ id, etapa }: { id: string; etapa: string }) => moverCandidatura(id, etapa),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['ats', 'pipeline', vagaId] })
      void qc.invalidateQueries({ queryKey: ['ats', 'vagas'] })
      void qc.invalidateQueries({ queryKey: ['ats', 'dashboard'] })
    },
  })

  return (
    <div className="hi-stack">
      {mover.isError ? <Alert tone="danger">Não foi possível mover a candidatura.</Alert> : null}
      <div className="hi-kanban">
        {ETAPAS_KANBAN.map((etapa) => {
          const cards = pipeline[etapa] || []
          const cor = ETAPA_COLORS[etapa] || '#64748b'
          return (
            <section key={etapa} className="card hi-kanban-col">
              <header style={{ borderTopColor: cor }}>
                <h4>{ETAPA_LABELS[etapa] || etapa}</h4>
                <span style={{ background: `${cor}22`, color: cor }}>{cards.length}</span>
              </header>
              <div className="hi-kanban-body">
                {cards.length === 0 ? <p className="hi-empty">Nenhum candidato</p> : null}
                {cards.map((c) => (
                  <article key={c.id} className="hi-kanban-card">
                    <Avatar nome={c.candidato_nome} size="sm" />
                    <div className="hi-kanban-card-main">
                      <strong>{c.candidato_nome || 'Candidato'}</strong>
                      <span>{c.candidato_email || c.origem_display || c.origem || '-'}</span>
                      {c.score_ia != null ? (
                        <em>IA {Number(c.score_ia).toLocaleString('pt-BR')}</em>
                      ) : null}
                    </div>
                    <label className="hi-kanban-move">
                      <span className="hi-sr-only">Mover etapa</span>
                      <select
                        value={c.etapa}
                        disabled={mover.isPending}
                        onChange={(e) => {
                          const next = e.target.value
                          if (next && next !== c.etapa) {
                            mover.mutate({ id: c.id, etapa: next })
                          }
                        }}
                      >
                        {ETAPAS_KANBAN.map((et) => (
                          <option key={et} value={et}>
                            {ETAPA_LABELS[et]}
                          </option>
                        ))}
                        <option value="reprovado">Reprovado</option>
                        <option value="desistiu">Desistiu</option>
                      </select>
                    </label>
                  </article>
                ))}
              </div>
            </section>
          )
        })}
      </div>
    </div>
  )
}
